import React from "react";
import UsePanel from "./UserPanel";

import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const DashboardOverview = () => {
  document.title = "Dashboard | mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Dashboard" />
          {/* User Panel Charts */}
          <UsePanel />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardOverview;
